'use client';

import type { HeadingBlock } from '@impact/types';
import type { ElementType } from 'react';

interface Props {
  block: HeadingBlock;
  editing?: boolean;
}

type HeadingLevel = 'h1' | 'h2' | 'h3' | 'h4';

const headingSizes: Record<HeadingLevel, string> = {
  h1: 'text-5xl md:text-7xl font-black',
  h2: 'text-4xl md:text-6xl font-black',
  h3: 'text-3xl md:text-5xl font-black',
  h4: 'text-2xl md:text-4xl font-black',
};

/**
 * Magazine variant: bold left border, serif-style presentation
 */
export function HeadingMagazine({ block, editing }: Props) {
  const { text, level, subtitle } = block.data;
  const Tag = level as ElementType;

  return (
    <header className="my-8 border-l-4 border-primary pl-6 py-2">
      {subtitle ? (
        <p
          className="text-xs uppercase tracking-[0.2em] text-muted-foreground mb-2"
          {...(editing ? { 'data-editable': 'data.subtitle' } : {})}
        >
          {subtitle}
        </p>
      ) : null}
      <Tag
        className={`${headingSizes[level as HeadingLevel]} text-foreground leading-none`}
        {...(editing ? { 'data-editable': 'data.text' } : {})}
      >
        {text}
      </Tag>
    </header>
  );
}
